export default function initialize(opportunite) {
  if (!opportunite || !opportunite.data || !opportunite.data.produits) {
    return;
  }
  if (Array.isArray(opportunite.data.produits.panneauxLc)) {
    opportunite.data.produits.panneauxLc.forEach((el) => {
      el.extensionOpportunite.date = el.date ? new Date(el.extensionOpportunite.date) : null;
      el.extensionOpportunite.dateDisponibilite = el.extensionOpportunite.dateDisponibilite
        ? new Date(el.extensionOpportunite.dateDisponibilite) : null;
      el.extensionOpportunite.dateFin = el.extensionOpportunite.dateFin
        ? new Date(el.extensionOpportunite.dateFin) : null;
    });
  }
  if (Array.isArray(opportunite.data.produits.reseauxLc)) {
    opportunite.data.produits.reseauxLc.forEach((el) => {
      el.extensionOpportunite.date = el.extensionOpportunite.date
        ? new Date(el.extensionOpportunite.date) : null;
    });
  }
  if (Array.isArray(opportunite.data.produits.reseauxPersonnalise)) {
    opportunite.data.produits.reseauxPersonnalise.forEach((el) => {
      el.dateDebut = el.dateDebut ? new Date(el.dateDebut) : null;
      el.dateFin = el.dateFin ? new Date(el.dateFin) : null;
    });
  }
  opportunite.dateValidite = opportunite.dateValidite ? new Date(opportunite.dateValidite) : null;

  if (opportunite.data.client && opportunite.data.client.nomCommercial) {
    opportunite.annonceur = opportunite.data.client.nomCommercial;
  }
}



// WEBPACK FOOTER //
// ./src/services/opportunite/opportuniteInitializer.js